import { mutate } from 'swr';
import { getCacheKey } from 'utils/getCacheKey';

export const mutateProjectPhases = () => {
  const searchedKey = getCacheKey('/phases');
  if (searchedKey) {
    mutate(searchedKey);
  }
};
